// Decisions about "negative payment" decorations must be driven solely by the
// server-provided `negativePayment` flag on a payment rollup entry. A negative
// payout on its own is not sufficient, since payouts may legitimately be
// negative for other reasons.

export const activityHasNegativePayment = (activity) => activity?.negativePayment === true

export const payeeHasNegativePayment = (payee) =>
  payee?.paymentRollup?.some(activityHasNegativePayment) ?? false

export const contractHasNegativePayment = (payeeInfo) =>
  payeeInfo?.some(payeeHasNegativePayment) ?? false
